/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessDeleteUserBody
 */
export interface BusinessDeleteUserBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessDeleteUserBody
     */
    userId: string;
}

/**
 * Check if a given object implements the BusinessDeleteUserBody interface.
 */
export function instanceOfBusinessDeleteUserBody(value: object): value is BusinessDeleteUserBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function BusinessDeleteUserBodyFromJSON(json: any): BusinessDeleteUserBody {
    return BusinessDeleteUserBodyFromJSONTyped(json, false);
}

export function BusinessDeleteUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessDeleteUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function BusinessDeleteUserBodyToJSON(json: any): BusinessDeleteUserBody {
    return BusinessDeleteUserBodyToJSONTyped(json, false);
}

export function BusinessDeleteUserBodyToJSONTyped(value?: BusinessDeleteUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
    };
}

